module.exports = __webpack_public_path__ + "img/liguangda.9a079bc9.jpeg";